export default {
  validation: {
    required: 'Esta es una pregunta obligatoria',
    kana_format: '',
    email_format: 'Escriba en @.lower:validation.variables.email',
    date_format: 'Escriba en @.lower:validation.variables.date',
    number_format: 'Escriba en @.lower:validation.variables.number',
    halfwidth_number_format: 'Escriba solo dígitos de la mitad del ancho',
    alphanumeric_format: 'Escriba en @.lower:validation.variables.alphanumeric',
    postal_number_no_hyphen: 'Escriba en @.lower:validation.variables.postal_number',
    postal_number_format: 'Escriba @:validation.variables.postal_number en Sin guiones',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: 'Escriba en 6 caracteres o más',
    min_length: 'Escriba en {length} caracteres o más',
    max_length: 'Escriba en {length} caracteres o menos',
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: 'Introduzca hasta {digit} caracteres.',
    max_digit_with_item: 'Introduzca {item} dentro de {digit} dígitos',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: 'No está permitido responder únicamente con espacios y/o saltos de línea.',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/dirección de correo electrónico',
      email: 'Dirección de correo electrónico',
      password: 'Contraseña',
      kana: '',
      date: 'Fecha (ej. 31/01/2023)',
      number: 'Número',
      alphanumeric: 'Alfabeto y números',
      postal_number: 'Código postal',
    },
  },
}
